import ToolLogoSvg from 'images/kidwk/logo.svg';

export const loanpart = {
  mortgageType: null,
  startDate: '',
  currentDebt: null,
};

let purchasePriceDefault = null;
const params = new URLSearchParams(window.location.search)
if (params.has('purchase_price')) {
  purchasePriceDefault = Number.parseFloat(params.get('purchase_price'));
}

export const whiteListUrlParams = [
  'purchase_price',
  'has_surplus_value',
  'surplus_value',
  'has_own_resources',
  'own_resources',
  // income
  'applicant_dob',
  'applicant_income',
  'applicant_income_perio',
  'applicant_holiday_bonus',
  'applicant_13th_month_salary',
  'applicant_is_entrepreneur',
  'applicant_is_entrepreneur_for_three_years',
  'applicant_entrepreneur_prognoses_current_year',
  'applicant_entrepreneur_fiscal_profit_last_year',
  'applicant_entrepreneur_fiscal_profit_two_years_ago',
  'applicant_entrepreneur_fiscal_profit_three_years_ago',
  // partner
  'applicant_has_partner',
  'partner_dob',
  'partner_income',
  'partner_income_period',
  'partner_holiday_bonus',
  'partner_13th_month_salary',
  'partner_is_entrepreneur',
  'partner_is_entrepreneur_for_three_years',
  'partner_entrepreneur_prognoses_current_year',
  'partner_entrepreneur_fiscal_profit_last_year',
  'partner_entrepreneur_fiscal_profit_two_years_ago',
  'partner_entrepreneur_fiscal_profit_three_years_ago',
  // mortgage
  'applicant_has_mortgage',
  'loanparts',
  'current_house_value',

  //lead information
  'email',
  'phone_number',

  // expenses
  'has_student_loan',
  'student_loan_monthly_payment',
  'has_partner_student_loan',
  'partner_student_loan_monthly_payment',
  'has_total_credits',
  'has_partner_total_credits',
  'total_credits',
  'partner_total_credits',
  'has_partner_alimony',
  'partner_alimony',
  'has_partner_partner_alimony',
  'partner_partner_alimony',
  'has_ground_rent',
  'ground_rent',
  'has_private_lease',
  'private_lease',
  'private_lease_duration',
  'has_partner_private_lease',
  'partner_private_lease',
  'partner_private_lease_duration',

  'new_regulations'
];

export default {
  app: 'kidwk',
  logo: ToolLogoSvg,
  framed: false,
  pages: ['landing', 'applicant', 'partner', 'expenses', 'final'],
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  input: {
    // landing
    purchase_price: purchasePriceDefault,
    new_house: false,
    has_surplus_value: false,
    surplus_value: null,
    has_own_resources: false,
    own_resources: null,
    // income
    applicant_dob: '',
    applicant_income: null,
    applicant_income_period: 'monthly',
    applicant_holiday_bonus: true,
    applicant_13th_month_salary: false,
    applicant_is_entrepreneur: false,
    applicant_is_entrepreneur_for_three_years: true,
    applicant_entrepreneur_prognoses_current_year: null,
    applicant_entrepreneur_fiscal_profit_last_year: null,
    applicant_entrepreneur_fiscal_profit_two_years_ago: null,
    applicant_entrepreneur_fiscal_profit_three_years_ago: null,
    // partner
    applicant_has_partner: false,
    partner_dob: '',
    partner_income: null,
    partner_income_period: 'monthly',
    partner_holiday_bonus: true,
    partner_13th_month_salary: false,
    partner_is_entrepreneur: false,
    partner_is_entrepreneur_for_three_years: true,
    partner_entrepreneur_prognoses_current_year: null,
    partner_entrepreneur_fiscal_profit_last_year: null,
    partner_entrepreneur_fiscal_profit_two_years_ago: null,
    partner_entrepreneur_fiscal_profit_three_years_ago: null,
    // mortgage
    applicant_has_mortgage: false,
    loanparts: [loanpart],
    current_house_value: null,
    // expenses
    has_student_loan: false,
    student_loan_monthly_payment: null,
    has_partner_student_loan: false,
    partner_student_loan_monthly_payment: null,
    has_total_credits: false,
    total_credits: null,
    has_partner_total_credits: false,
    partner_total_credits: null,
    has_partner_alimony: false,
    partner_alimony: null,
    has_partner_partner_alimony: false,
    partner_partner_alimony: null,
    has_ground_rent: false,
    ground_rent: null,
    private_lease: null,
    has_private_lease: false,
    private_lease_duration: null,
    has_partner_private_lease: false,
    partner_private_lease: null,
    partner_private_lease_duration: null,
    //energy label
    energy_label: 'E',

    //lead information
    email: null,
    phone_number: null,

    //final
    new_regulations: false,
    // client-side only
    show_disclaimer: false,
    info_box: null,
    show_additional_costs: false,
    applicant_pension_income_period: 'yearly',
    partner_pension_income_period: 'yearly',
  },
  output: {
    show_applicant_pension_income: false,
    show_partner_pension_income: false,
    errors: {},
    possibility: {},
  },
};
